import { ReactNode } from 'react';

interface Props<T> {
  value: T | null | undefined;
  expression: (value: T) => ReactNode | null;
  defaultValue?: ReactNode | null;
}

export const Convert = <T,>({ value, expression, defaultValue = null }: Props<T>) => {
  if (value != null) return <>{expression(value)}</>;
  return <>{defaultValue}</>;
};
